import type { TypographyVariant } from 'src/app/components/Elements/Typography';

import type { ANCHOR_TYPES } from '../Anchor';
import { Anchor } from '../Anchor';

import { IconAndTextContainer, StylizedCapsuleIcon } from './styles';
import { TextList } from './TextList';

interface IconAndTextProps {
  iconString: string;
  textList: string[];
  textColor?: string;
  textVariant?: TypographyVariant;
  anchorOptions?: { type: ANCHOR_TYPES; href: string };
}

export const IconAndText = ({
  textList,
  iconString,
  anchorOptions,
  textColor = 'capsuleGreen60',
  textVariant = 'body',
}: IconAndTextProps) => {
  return (
    <IconAndTextContainer>
      <StylizedCapsuleIcon iconString={iconString} block />
      <div>
        {anchorOptions ? (
          <Anchor type={anchorOptions.type} href={anchorOptions.href}>
            <TextList textList={textList} textVariant={textVariant} textColor={textColor} />
          </Anchor>
        ) : (
          <TextList textList={textList} textVariant={textVariant} textColor={textColor} />
        )}
      </div>
    </IconAndTextContainer>
  );
};
